// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-1xbdt"};